import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, ThemeProvider } from "@mui/material";
import Navbar from "./components/Navbar";
import Footer from "./components/dashboard/DashboardFooter";
import Login from "./components/Login";
import useAuthUser from "./components/hooks/useAuthUser";
import { dashboardLayout } from "./components/dashboard/layoutTokens";
import useSidebarPreference from "./components/dashboard/useSidebarPreference";
import dashboardTheme from "./theme/dashboardTheme";
import "./components/dashboard/dashboard.css";

export default function Layout() {
  const { isLoggedIn, user } = useAuthUser();
  const { pathname } = useLocation();
  const [sidebarCollapsed, toggleSidebar] = useSidebarPreference("primary");
  const sidebarWidth = sidebarCollapsed ? dashboardLayout.collapsedSidebarWidth : dashboardLayout.sidebarWidth;
  const fullHeight = pathname === "/chat" || pathname === "/settings" || pathname === "/campaign" || pathname === "/agent/new" || pathname.startsWith("/agent/edit/");
  return <ThemeProvider theme={dashboardTheme}>
    <Box className="dashboard-shell">
      <a className="dashboard-skip-link" href="#dashboard-main">Skip to workspace</a>
      <Navbar isLoggedIn={isLoggedIn} user={user} collapsed={sidebarCollapsed} onToggleCollapse={toggleSidebar} />
      <Box id="dashboard-main" component="main" tabIndex={-1} sx={{ ml: { lg: isLoggedIn ? `${sidebarWidth}px` : 0 }, pt: `${dashboardLayout.headerHeight}px`, minWidth: 0, outline: "none" }}>
        <Box sx={{ minHeight: `calc(100dvh - ${dashboardLayout.headerHeight}px)`, ...(isLoggedIn && fullHeight ? { height: `calc(100dvh - ${dashboardLayout.headerHeight}px)`, overflow: "hidden" } : {}), display: "flex", flexDirection: "column", minWidth: 0 }}>
          {isLoggedIn ? <Outlet /> : <Login />}
          {isLoggedIn && !fullHeight && <Footer />}
        </Box>
      </Box>
    </Box>
  </ThemeProvider>;
}
